import * as svg from "../../../assets/grid-dots.svg";

import {iconBuilder} from "./iconBuilder";

const GridDotsIcon = iconBuilder(svg, "GridDotsIcon", "0 0 13 14");

export default GridDotsIcon;
